import SideNavigation from "./SideNavigation";
import { useSidebar } from "../context/SidebarProvider";
import { useLang } from "../context/TranslationProvider";
import { useAuth } from "../context/AuthContext";

import {
  Home,
  Database,
  Users,
  FileText,
  Newspaper,
  Megaphone,
  CalendarDays,
  LayoutDashboard,
  ShoppingCart,
  LogOut,
  LogIn,
  PlusCircle
} from "lucide-react";

export default function AppSidebar() {
  const { user, logout } = useAuth();
  const { t, direction } = useLang();
  const { closeSidebar } = useSidebar();

  const handleLogOut = () => {
    logout();
    closeSidebar();
  };

  const navItems = [
    { section: t("main") },

    { label: t("Home"), icon: <Home size={20} />, to: "/", onClick: closeSidebar },

    // { label: t("Entities"), icon: <Database size={20} />, to: "/entities", onClick: closeSidebar },

    // { label: t("Tenants"), icon: <Users size={20} />, to: "/bookings", onClick: closeSidebar },

    // { label: t("Providers"), icon: <Users size={20} />, to: "/organizations", onClick: closeSidebar },

    // { label: t("Records"), icon: <FileText size={20} />, to: "/reservations", onClick: closeSidebar },

    // { label: t("Manage Entities"), icon: <LayoutDashboard size={20} />, to: "/adminmanageentities", onClick: closeSidebar },

    // { label: t("News"), icon: <Newspaper size={20} />, to: "/news", onClick: closeSidebar },

    // { label: t("Announcements"), icon: <Megaphone size={20} />, to: "/announcement", onClick: closeSidebar },

    // { label: t("Events"), icon: <CalendarDays size={20} />, to: "/events", onClick: closeSidebar },

    ...([
      {
        label: t("Add Entity"),
        icon: <PlusCircle size={20} className="text-orange-500 dark:text-orange-300" />,
        to: "/adminaddentity",
        onClick: closeSidebar
      },
      {
        label: t("Dashboard"),
        icon: <LayoutDashboard size={20} />,
        to: "/admindashboard",
        onClick: closeSidebar
      },
      {
        label: t("Products"),
        icon: <ShoppingCart size={20} />,
        to: "/listings",
        onClick: closeSidebar
      },
      {
        label: t("Packages"),
        icon: <ShoppingCart size={20} />,
        to: "/packages",
        onClick: closeSidebar
      }
    ]),

    ...(user
      ? [
          {
            label: t("logout"),
            icon: <LogOut size={20} />,
            onClick: handleLogOut
          }
        ]
      : [
          {
            label: t("login"),
            icon: <LogIn size={20} />,
            to: "/login",
            onClick: closeSidebar
          }
        ])
  ];

  return (
    <SideNavigation
      width={240}
      side={direction == "rtl" ? "right" : "left"}
      header={<span className="text-xl font-bold">{t("Dashboard")}</span>}
      items={navItems}
    />
  );
}